import { j as m } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as p, useEffect as i } from "react";
import { u as d, F as n } from "../../../../react-hook-form.Du3weLRK.js";
import { getDefaultValuesBySyncType as t, getResolverBySyncType as k } from "./model.js";
const D = p(({
  children: a,
  syncType: e,
  datasetManifestHash: o
}) => {
  const l = t(o, e), u = k(e), r = d({
    defaultValues: l,
    mode: "onChange",
    reValidateMode: "onChange",
    resetOptions: {
      // NOTE: It's gonna be a completely new form, resetting everything explicitly
      keepDefaultValues: !1,
      keepDirty: !1,
      keepDirtyValues: !1,
      keepErrors: !1,
      keepIsSubmitted: !1,
      keepIsValid: !1,
      keepSubmitCount: !1,
      keepTouched: !1,
      keepValues: !1
    },
    resolver: u,
    shouldUnregister: !1
  }), {
    reset: s
  } = r;
  return i(() => {
    const f = t(o, e);
    s(f);
  }, [o, s, e]), /* @__PURE__ */ m.jsx(n, { ...r, children: a });
});
D.displayName = "DqDatasetExportFormProvider";
export {
  D as default
};
//# sourceMappingURL=DqDatasetExportFormProvider.js.map
